module.exports = "<div class=\"container\">\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/footer.html
// module id = 40
// module chunks = 0